(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(() => {
  if (customElements.get('cart-shipping-accordion')) return;

  class CartShippingAccordion extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.panel = this.querySelector('[data-shipping-panel]');
      this.template = this.querySelector('[data-shipping-template]');
      if (!this.details || !this.panel || !this.template) return;

      this.onToggle = () => {
        if (this.details.open) this.mountCalculator();
        else this.clearResults();
        this.updateState();
      };

      this.details.addEventListener('toggle', this.onToggle);
      this.observer = new MutationObserver(() => this.updateState());
      this.observeResult();
      if (this.details.open) this.mountCalculator();
      this.updateState();
    }

    disconnectedCallback() {
      this.details?.removeEventListener('toggle', this.onToggle);
      this.observer?.disconnect();
    }

    mountCalculator() {
      if (this.panel.querySelector('[data-calculo-frete]')) return;

      const fragment = this.template.content.cloneNode(true);
      const initializer = fragment.querySelector('script');
      initializer?.remove();
      this.panel.appendChild(fragment);

      // O snippet usa listeners delegados e uma proteção global contra duplicação.
      // Ativa seu único script apenas se ainda não foi executado na página.
      // Também atende ao primeiro produto adicionado a um carrinho inicialmente vazio.
      if (initializer && !window.__sportbrFreteInicializado) {
        const script = document.createElement('script');
        if (initializer.nonce) script.nonce = initializer.nonce;
        script.textContent = initializer.textContent;
        this.panel.appendChild(script);
      }

      const input = this.panel.querySelector('[data-frete-cep]');
      input?.parentElement.setAttribute('data-shipping-entry', '');
      this.observeResult();
    }

    observeResult() {
      this.result = this.panel.querySelector('[data-frete-result]');
      if (!this.result) return;
      this.observer.observe(this.result, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style']
      });
    }

    updateState() {
      // Descarta também uma resposta que terminou depois de recolher o accordion.
      if (!this.details.open && this.result?.hasChildNodes()) {
        this.clearResults();
      }

      const hasResults = Boolean(
        this.details.open && this.result?.querySelector('tbody tr') &&
        getComputedStyle(this.result).display !== 'none'
      );

      const summary = this.details.querySelector('summary');
      if (hasResults && !this.classList.contains('has-shipping-results') &&
          this.panel.contains(document.activeElement)) {
        summary.focus({ preventScroll: true });
      }

      this.classList.toggle('has-shipping-results', hasResults);
      summary.setAttribute('aria-label',
        this.details.open ? 'Recolher cálculo de frete' : 'Calcular Frete'
      );
    }

    clearResults() {
      if (this.result) {
        this.result.replaceChildren();
        this.result.style.display = 'none';
      }
      this.classList.remove('has-shipping-results');
    }
  }

  customElements.define('cart-shipping-accordion', CartShippingAccordion);
})();

  } catch(e) { console.error(e); }
})();
})();
